import { configHome, DataSource } from "@pub/config";
import { ContentBlock } from "@sphtech/dmg-design-system";
import ProductDeals from "@src/app/components/Modules/Product/ProductDeals";
import cx from "classnames";
import { ReactNode } from "react";

import styles from "../homelayout.module.css";
import { extractHomeContentData, HomeLayoutProps } from "./utils";

type Props = {
  data: HomeLayoutProps["data"];
  dataSource: DataSource;
  alternateBg?: boolean;
};

// Product Deals | Affiliate Products
export default function HomeAffiliateProduct({
  data,
  dataSource,
  alternateBg,
}: Props): ReactNode {
  const affiliateProduct = extractHomeContentData(data, dataSource);

  return (
    affiliateProduct &&
    affiliateProduct.items.length > 0 && (
      <div
        className={cx(
          styles.affiliateProductContainer,
          alternateBg && styles.backgroundFill,
        )}
      >
        <div className={cx(styles.bodyContainer, styles.gutter)}>
          <ContentBlock
            heading={affiliateProduct.title || "editor’s picks"}
            headingZH={affiliateProduct.titleZH}
            withDivider={configHome.headingDivider}
            description={configHome.affiliateProduct?.description}
          >
            <ProductDeals
              data={{
                items: affiliateProduct.items,
                carouselWidthLeeWay:
                  configHome.affiliateProduct?.carouselWidthLeeWay,
                itemWidth: configHome.affiliateProduct?.itemWidth,
              }}
            />
          </ContentBlock>
        </div>
      </div>
    )
  );
}
